module.exports = __webpack_public_path__ + "static/img/zdhf08.0fd89e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf08.png
// module id = 126
// module chunks = 0